import React, { Component } from "react";
import { Button, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { parseISO } from "date-fns";
import { COMMON_PROPERTIES } from "properties/client";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

var dateFormat = COMMON_PROPERTIES.DB_DATE_ONLY_FORMAT;
class RangeSelectorDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        startDate:
          props.startDate === undefined
            ? moment()
              // .hours("00")
              // .minutes("00")
              // .seconds("00")
              .format(dateFormat)
            : props.startDate,
        endDate:
          props.endDate === undefined
            ? moment()
              // .hours("23")
              // .minutes("59")
              // .seconds("59")
              .format(dateFormat)
            : props.endDate,
      },
      dateDiffSetter: this.dateDiffSetter.bind(this),
    };
  }
  dateDiffSetter(selectedRange) {
    const { data } = this.state;
    var startDate = new Date();
    var endDate = new Date();
    switch (selectedRange.toLowerCase()) {
      case "1d":
        startDate.setDate(startDate.getDate() - 1);
        break;
      case "3d":
        startDate.setDate(startDate.getDate() - 3);
        break;
      case "7d":
        startDate.setDate(startDate.getDate() - 7);
        break;
      case "15d":
        startDate.setDate(startDate.getDate() - 15);
        break;
      case "1m":
        startDate.setMonth(startDate.getMonth() - 1);
        break;
      case "3m":
        startDate.setMonth(startDate.getMonth() - 3);
        break;
      case "6m":
        startDate.setMonth(startDate.getMonth() - 6);
        break;
      case "1y":
        startDate.setMonth(startDate.getMonth() - 12);
        break;
      case "mtd":
        startDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        break;
      case "ytd":
        startDate = new Date(new Date().getFullYear(), 0, 1);
        break;
      default:
        startDate = new Date();
    }
    data["endDate"] = moment(endDate).format(dateFormat);
    data["startDate"] = moment(startDate)
      //   .hours("00")
      //   .minutes("00")
      //   .seconds("00")
      .format(dateFormat);
    this.setState({ data });
    this.props.getDateValue(this.state.data);
  }
  submitForm = () => {
    this.props.getDateValue(this.state.data);
  };
  componentDidMount() {
    this.props.getDateValue(this.state.data);
  }
  componentWillUnmount() {
    this.props.getDateValue(this.state.data);
  }
  handleDateChange = (date, key) => {
    const { data } = this.state;
    data[key] = moment(date).format(dateFormat);
    this.setState({ data });
  };
  render() {
    const { data } = this.state;
    return (
      <div className="container">
        <Row id="" className="rangeSelectorRow align-items-center">
          {/* <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("1d")}
            >
              1d
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("3d")}
            >
              3d
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("7d")}
            >
              7d
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("15d")}
            >
              15d
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("1m")}
            >
              1m
            </Button>
          </div> */}
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("3m")}
            >
              3m
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("6m")}
            >
              6m
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("mtd")}
            >
              MTD
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("ytd")}
            >
              YTD
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <Button
              size="sm"
              color="secondary"
              onClick={() => this.dateDiffSetter("1y")}
            >
              1y
            </Button>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <label className="react-datepicker-label">Start Date : </label>
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <DatePicker
              selected={parseISO(data.startDate)}
              onChange={(date) => this.handleDateChange(date, "startDate")}
            //  showTimeSelect
            //  timeFormat="HH:mm"
              timeIntervals={15}
            //  timeCaption="time"
              dateFormat="yyyy-MM-dd"
            //  excludeOut
            />
          </div>
          <div col="6" className="mb-xl-1 ml-1">
            <label className="react-datepicker-label">End Date : </label>
          </div>

          <div col="6" className="mb-xl-1 ml-1">
            {/*<label className="react-datepicker-label">End Date : </label> */}
            <DatePicker
              selected={parseISO(data.endDate)}
              onChange={(date) => this.handleDateChange(date, "endDate")}
             // showTimeSelect
            //  timeFormat="HH:mm"
              timeIntervals={15}
            //  timeCaption="time"
              dateFormat="yyyy-MM-dd"
            //  excludeOut
            />
          </div>
          <div col="6" className="mb-xl-1 ml-2">
            <Button size="sm" color="secondary" onClick={() => this.submitForm()}>
              Refresh
            </Button>
          </div>
        </Row>
      </div>
    );
  }
}
export default RangeSelectorDate;
